<template>
  <div :class="`
    work-bench-workpackage-header
    ${color}
    ${color && color.includes('lighten') || color && color.includes('darken')? '':'lighten-1'}
    `"
    :style="width?`width: ${width}`:''"
    >
    <template v-if="!no_color_picker">
      <div>
        <TIcon
          class="cursor-pointer work-bench-workpackage-header-icon"
          :zoom="1"
          :name="getNewIcon(icon)"
          :color="text_color"
          medium
          @click.native.prevent.stop="$emit('clickIcon')"/>
      </div>
      <!-- <v-icon
        class="cursor-pointer"
        v-if="icon && isStandardIcon(icon)"
        :color="text_color?text_color:'black'"
        @click.prevent.stop="$emit('clickIcon')"
        >
        {{icon}}
      </v-icon>
      <svg-icon
        v-else-if="icon && isSvgIcon(icon)"
        class="cursor-pointer"
        :name="icon"
        :size="20"
        :style="`fill: ${text_color?`${text_color}`:'black'}; height: 20px`"
        @click.native.prevent.stop="$emit('clickIcon')"
      /> -->
    </template>
    <!-- without click, had some issue with recommended waggon in sequence editor -->
    <template v-else>
      <TIcon
        class="cursor-pointer work-bench-workpackage-header-icon"
        :name="getNewIcon(icon)"
        :color="text_color"
        medium
        @click.native.prevent.stop="$emit('clickIcon')"/>
      <!-- <v-icon
        class="cursor-pointer"
        v-if="icon && isStandardIcon(icon)"
        :color="text_color?text_color:'black'"
        >
        {{icon}}
      </v-icon>
      <svg-icon
        v-else-if="icon"
        class="cursor-pointer"
        :name="icon"
        :size="20"
        :style="`fill: ${text_color?`${text_color}`:'black'}; height: 20px`"
      /> -->
    </template>
    <div class="ml-2 work-bench-workpackage-header-text">
      <slot name="text"/>
    </div>
    <!-- <div>-</div> -->
    <!-- <div>{{name}}</div> -->
    <div class="work-bench-workpackage-header-actions">
      <slot name="actions">
        <div
          v-if="!no_color_picker"
          class="work-bench-workpackage-colorpicker-icon"
          @click.prevent.stop="$emit('clickColorPicker')"
          />
      </slot>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  export default {
    props: ['icon', 'token', 'color', 'text_color', 'name', 'width', 'no_color_picker'],
    data: () => ({
    }),
    components: {
      TIcon
    },
    computed: {
      ...mapGetters('TWorkPackage', [
        'isStandardIcon'
      ]),
      ...mapGetters('WorkPackage', [
        'getNewIcon',
      ]),
      ...mapGetters('View', [
        'isSvgIcon'
      ])
    }
  }
</script>
<style>
  .work-bench-workpackage-header {
    display: flex;
    position: relative;
    width: 100%;
    padding: 3px;
    transition: all ease-in-out 0.2s;
  }
  .work-bench-workpackage-header-icon {
    flex-shrink: 0;
  }
  .work-bench-workpackage-header-text {
    display: flex;
    user-select: none;
  }
  .work-bench-workpackage-colorpicker-icon {
    position: absolute;
    right: 3px;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    border: solid black 1px;
    cursor: pointer;
    /* background: conic-gradient(red, yellow, lime, aqua, blue, magenta, red); */
    background: conic-gradient(#EF5350, #FFEE58, #D4E157, #29B6F6, #42A5F5, #EC407A, #EF5350);
  }
  .work-bench-workpackage-header-actions {
    position: absolute;
    right: 3px;
    display: flex;
  }
  </style>
